/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Guestaccount1Inputs */

const de__field_guestaccount1 = /** @type {(inputs: _Field_Guestaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gast-Account`)
};

/**

* @param {_Field_Guestaccount1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_guestaccount1 = /** @type {((inputs?: _Field_Guestaccount1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Guestaccount1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_guestaccount1(inputs)
});
export { _field_guestaccount1 as "_field_guestAccount" }